"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.META_API_FINISHED = exports.UNAUTHORIZED = exports.ERROR = exports.SUCCESS = void 0;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var ERROR = 'ERROR';
exports.ERROR = ERROR;
var UNAUTHORIZED = 'UNAUTHORIZED';
exports.UNAUTHORIZED = UNAUTHORIZED;
var META_API_FINISHED = 'META_API_FINISHED';
exports.META_API_FINISHED = META_API_FINISHED;